import { Stack, SxProps } from '@mui/material';

import { SearchFilter } from '../SearchFilter';

type RelativelyPositionedSearchFilterProps = {
  inputValue: string;
  setInputValue: (value: string) => void;
  placeholder?: string;
  sx?: SxProps;
};

export const RelativelyPositionedSearchFilter = ({
  inputValue,
  setInputValue,
  placeholder,
  sx,
}: RelativelyPositionedSearchFilterProps) => (
  <Stack direction={'row'} justifyContent={'end'} p={2} pb={0} sx={{ width: '100%' }}>
    <Stack mb={'-35px'} sx={{ zIndex: 1, position: 'relative', ...sx }}>
      <SearchFilter
        filterValue={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={placeholder}
      />
    </Stack>
  </Stack>
);
